<div class="language-selector">
    <span 
        class="language-option"
        [class.active]="currentLanguage === 'de'"
        (click)="setLanguage('de')">
        DE
    </span>
    <span class="divider">|</span>
    <span 
        class="language-option"
        [class.active]="currentLanguage === 'en'"
        (click)="setLanguage('en')">
        EN
    </span>
</div> 